import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

export default function DynamicNav({ links, onLinkClick }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (e, url) => {
    e.preventDefault();
    if (url.startsWith("#")) {
      if (location.pathname !== "/") {
          window.location.href = "/" + url;
      } else {
        const element = document.getElementById(url.slice(1));
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    } else {
      navigate(url);
    }
    if (onLinkClick) {
      onLinkClick();
    }
  };
  
  const compareBaseURL = (currentPath, linkPath) => {
    const normalizedCurrent = currentPath.startsWith('/') ? currentPath : `/${currentPath}`;
    const normalizedLink = linkPath.startsWith('/') ? linkPath : `/${linkPath}`;
    
  
    const cleanCurrent = normalizedCurrent.replace(/\/+$/, '');
    const cleanLink = normalizedLink.replace(/\/+$/, '');
    
  
    if (cleanCurrent === cleanLink) {
      return true;
    }

    if (cleanLink === '/dashboard') {
      return cleanCurrent === '/dashboard';
    }
    
    if (cleanCurrent.startsWith(cleanLink + '/')) {
      return true;
    }
    
    const getBasePath = (path) => {
      const segments = path.split('/').filter(Boolean);
      return segments.slice(0, 3).join('/');
    };
    return getBasePath(normalizedCurrent) === getBasePath(normalizedLink);
  };

  return (
    <>
      {links.map((link) => {
        const isActive = compareBaseURL(location.pathname, link.url);
        return (
          <Link
            to={link.url}
            key={link.url}
            reloadDocument={true}
            onClick={(e) => handleClick(e, link.url)}
            className="block"
          >
            <div
              className={`
                flex items-center gap-3 px-4 py-3 rounded-lg
                transition-all duration-200 ease-in-out
                ${isActive && link.src
                  ? "bg-gray2" 
                  : "hover:bg-gray2"
                }
              `}
            >
              {link.src && (
                <img 
                  src={link.src} 
                  alt={`${link.text} icon`} 
                  className={`
                    w-6 h-6 object-contain flex-shrink-0 
                    ${isActive ? "brightness-0 saturate-100 hue-rotate-[345deg]" : ""}
                  `}
                  style={isActive ? {
                    filter: 'invert(35%) sepia(95%) saturate(2449%) hue-rotate(360deg) brightness(98%) contrast(106%)'
                  } : {}}
                />
              )}
              <span 
                className={`
                  xl:text-menuMSB xxl:text-bodyLR
                  ${isActive && link.src ? "text-primary" : "text-dark5"}
                `}
              >
                {link.text}
              </span>
            </div>
          </Link>
        );
      })}
    </>
  );
}
